import { Alert, Button, Popconfirm } from 'antd'
import { Authorized } from '@/features/authorization/authorized.tsx'
import { formatAmount } from '@/utils/money.ts'
import type { useIssuedBills } from './hooks/use-issued-bills.ts'

export function BillIssueNotice({
  error,
  drafts,
  issue,
  issuing
}: Pick<ReturnType<typeof useIssuedBills>, 'error' | 'drafts' | 'issue' | 'issuing'>) {
  if (error) {
    return <Alert type="error" showIcon title="当前无法保存" description={error} />
  }
  if (!drafts.length) {
    return null
  }
  return (
    <Alert
      type="warning"
      showIcon
      title={`有 ${drafts.length} 张草稿账单尚未确认出账`}
      description={
        <div className="flex flex-col items-start gap-2">
          <p>{drafts.map((b) => `${b.billNo}（¥${formatAmount(b.totalAmount)}）`).join('、')}</p>
          <p>先核对账单金额并确认出账，再保存本表单；已填写的内容会保留。确认出账不会登记实际收付款。</p>
          <Authorized permissions={['bill.issue']}>
            <Popconfirm
              title={`确认这 ${drafts.length} 张草稿出账？`}
              description="出账后成为正式账单，金额变更需通过账单调整。"
              okText="确认出账"
              onConfirm={issue}
            >
              <Button loading={issuing}>确认出账并继续</Button>
            </Popconfirm>
          </Authorized>
        </div>
      }
    />
  )
}
